"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var TreeAllocation = (function () {
    function TreeAllocation() {
    }
    TreeAllocation.prototype.convertTreeObjToAddressArray = function (treeObj, resultArr, address) {
        if (resultArr === void 0) { resultArr = []; }
        if (address === void 0) { address = '0'; }
        if (!treeObj)
            return resultArr;
        resultArr.push({
            id: treeObj.id,
            address: address,
        });
        if (!treeObj.children || treeObj.children.length === 0)
            return resultArr;
        for (var i = 0; i <= treeObj.children.length; i++) {
            this.convertTreeObjToAddressArray(treeObj.children[i], resultArr, address + "." + i);
        }
        return resultArr;
    };
    TreeAllocation.prototype.getMergedJSON = function (id, banks, tree) {
        var arrAddress = this.convertTreeObjToAddressArray(JSON.parse(JSON.stringify(tree)));
        var find = arrAddress.find(function (val) { return val.id === id; });
        if (!find) {
            var component_1 = __assign({}, banks[id]);
            delete component_1.banks;
            delete component_1.tree;
            delete component_1.children;
            return JSON.parse(JSON.stringify(component_1));
        }
        var realAddress = find.address.replace(/\./g, ".children.").replace("0", 'tree');
        var parentTree = lodash_1.default.get({ tree: tree }, realAddress);
        var component = banks[parentTree.id];
        if (!component)
            throw new Error("Component " + parentTree.id + " not found");
        parentTree.from = component.from;
        parentTree.props = component.props;
        parentTree.style = component.style;
        parentTree.tree = {
            children: parentTree.children.slice(),
        };
        delete parentTree.children;
        var idArr = this.convertTreeObjToAddressArray(parentTree.tree).filter(function (val) { return !!val.id; }).map(function (val) { return val.id; });
        parentTree.banks = {};
        idArr.forEach(function (componentId) {
            parentTree.banks[componentId] = banks[componentId];
        });
        return JSON.parse(JSON.stringify(parentTree));
    };
    return TreeAllocation;
}());
exports.default = new TreeAllocation();
//# sourceMappingURL=TreeAllocation.js.map